import SocialMedia from "components/About/SocialMedia";
import HeroConsulting from "components/Consulting/HeroConsulting";
import ListConsults from "components/Consulting/ListConsults";
import MissionConsult from "components/Consulting/MissionConsult";
import QuoteConsult from "components/Consulting/QuoteConsult";
import LatestWorkshop from "components/Homepage/LatestWorkshop";
import PriceSection from "components/Service/PriceSection";
import React, { useEffect } from "react";
import BookSection from "components/Events/BookSection";
import { useLocation } from "react-router-dom";

const Consulting = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");

      setTimeout(() => {
        const element = document.getElementById(id);

        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  }, [location]);
  return (
    <div>
      {/* <HeroConsulting /> */}
      <MissionConsult />
      <QuoteConsult />
      <div id="consulting">
        <ListConsults />
      </div>
      <BookSection />
    </div>
  );
};

export default Consulting;
